<template>
  <div id="interprets">
    <app-menu></app-menu>
    <admin-list-component
        :title="'Admin.menu.interprets' | staticTranslation"
        :add-text="'Admin.components.addInterpret' | staticTranslation"
        edit-path="/admin/program/interpret/edit/"
        entity-name="interpret"
        :get-name-function="getName"
        draggable="true"
    />
  </div>
</template>

<script>
import AdminMenu from "@/components/admin/AdminMenu";
import AdminListComponent from "@/components/admin/AdminListComponent";

export default {
  name: "programInterpret",
  components: {
    'app-menu': AdminMenu,
    'admin-list-component': AdminListComponent
  },
  methods: {
    getName: function (interpret) {
      return this.$options.filters.translation(interpret.name) + " ("
          + this.$options.filters.translation(interpret.periodName) + ")";
    }
  }
}
</script>

<style scoped>
#interprets {
  background-color: white;
  min-height: 100vh;
  overflow: hidden;
}
</style>
